import styled from 'styled-components';
import { Typography } from '../../global/theme';

const SelectContainer = styled.div`
  position: relative;
  width: 100%;
  margin: 0px 24px;
  width: calc(100% - 48px) !important;
`;

const SelectInput = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  cursor: text;
  flex-wrap: wrap;
  cursor: text;
  *::selection {
    background: transparent;
    color: inherit;
  }
`;

const Tag = styled.div`
  display: flex;
  align-items: center;
  background: var(--neutral-secondary);
  border-radius: 20px;
  padding: 4px 6px 4px 4px;
  border: 0.5px solid var(--border-primary);
  gap: 4px;
`;

const TagAvatar = styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  overflow: hidden;
  .teamcampicon {
    rect {
      fill: var(--background-tertiary) !important;
      stroke: var(--border-primary) !important;
    }
    path {
      fill: var(--text-primary) !important;
    }
  }
`;

const TagName = styled.span`
  white-space: nowrap;
  font-size: 14px;
  color: var(--text-primary);
`;

const TagClose = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  &:hover {
    background: var(--neutral-tertiary);
  }
`;

const Dropdown = styled.div<{ isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 16px);
  left: 0;
  width: 100%;
  max-height: 180px;
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  border-radius: 0 0 8px 8px;
  box-shadow: var(--shadow-dropdown);

  z-index: 1000;
  display: ${(props) => (props.isOpen ? 'block' : 'none')};
  padding: 4px 0;
  overflow-y: auto;
  ::-webkit-scrollbar-thumb {
    background: var(--text-placeholder);
    border-radius: 12px;
    min-height: 28px;
  }
`;

const SearchInput = styled.input`
  width: 100%;
  padding: 8px 12px;
  border: none;
  border-bottom: 0.5px solid var(--border-primary);
  background: transparent;
  color: var(--text-primary);
  &:focus {
    outline: none;
  }
`;

const Option = styled.div<{ selected?: boolean; focused?: boolean }>`
  padding: 4px 6px;
  margin: 0px 4px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  background: ${(props) =>
    props.focused
      ? 'var(--neutral-secondary)' // hover/focused color
      : props.selected
      ? 'var(--neutral-secondary)' // fallback for selected if not hovered
      : 'transparent'};
  &:hover {
    background: var(--neutral-secondary);
  }
`;

const OptionAvatar = styled.div`
  width: 28px;
  height: 28px;
  border-radius: 50%;
  overflow: hidden;
  .teamcampicon {
    rect {
      fill: var(--background-tertiary) !important;
      stroke: var(--border-primary) !important;
    }
    path {
      fill: var(--text-primary) !important;
    }
  }
`;

const OptionName = styled.span`
  ${Typography.body_md}
  white-space: nowrap;
  overflow: hidden;
  color: var(--text-primary);
`;

const Input = styled.input`
  border: none;
  outline: none;
  background: transparent;
  color: var(--text-primary);
  ${Typography.body_lg}
  :placeholder {
    color: var(--text-placeholder);
  }
  width: 100%;
  flex: 1;
  padding: 2px 0 0 0;
`;
export {
  SelectContainer,
  SelectInput,
  Tag,
  TagAvatar,
  TagName,
  TagClose,
  Dropdown,
  SearchInput,
  Option,
  OptionAvatar,
  OptionName,
  Input
};
